import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import thunkMiddleware from "redux-thunk";
import { analyticsMiddleware } from "analytics_middleware";
import rootReducer from "../reducers";

import apiMiddleware from "../middleware/api";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

let store = null;

export default function configureStore() {
	if (store !== null) return store;

	store = createStore(
		rootReducer,
		composeEnhancers(
			applyMiddleware(thunkMiddleware, apiMiddleware, analyticsMiddleware)
		)
	);

	if (module.hot) {
		// Enable Webpack hot module replacement for reducers
		module.hot.accept("../reducers", () => {
			store.replaceReducer(rootReducer);
		});
	}

	return store;
}
